import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset, change } from 'redux-form';
import LocalShipmentDialog from './LocalShipmentDialog';
import { IApplicationState } from 'ducks/reducers';
import { selectors as staffSelectors } from 'ducks/staff';

const formName = 'ProcessPurchaseOrdersForm';
const formLocalShipmentLeftPanelFrom = 'LocalShipmentLeftPanelFrom';
const formLocalShipmentRightPanelFrom = 'LocalShipmentRightPanelFrom';

const mapStateToProps = (state: IApplicationState) => ({
  dirty: isDirty(formName)(state),
  values: getFormValues(formName)(state),
  valuesLocalShipmentLeftPanelFrom: getFormValues(formLocalShipmentLeftPanelFrom)(state),
  valuesLocalShipmentRightPanelFrom: getFormValues(formLocalShipmentRightPanelFrom)(state),
  isValid: isValid(formName)(state),
  currentUserId: staffSelectors.id(state) ? staffSelectors.id(state) : ''
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset(formName),
    changeFormFieldValue: (fieldName: string, fieldValue: any) => change(formName, fieldName, fieldValue),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LocalShipmentDialog);
